import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Account = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get the operation type from URL parameters
    const operation = searchParams.get('mode');
    
    // Create URL search params string from all current parameters
    const queryString = searchParams.toString();

    // Route to appropriate page based on operation
    switch (operation) {
      case 'verifyEmail':
        navigate(`/auth/verify?${queryString}`, { replace: false });
        break;
      case 'resetPassword':
        navigate(`/auth/resetPassword?${queryString}`, { replace: false });
        break;
      case 'lock':
        navigate(`/auth/lock?${queryString}`, { replace: false });
        break;
      default:
        // If no operation specified or invalid operation, redirect to signin
        navigate(`/auth/signin?${queryString}`, { replace: false });
    }
  }, [navigate, searchParams]);

  // Return null since this is just a routing component
  return null;
};

export default Account; 